import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomerMyChartersRoutingModule } from './customer-my-charters-routing.module';
import { CustomerMyChartersComponent } from './customer-my-charters.component';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MyChartersCardModule } from '../../shared/my-charters-card/my-charters-card.module';
import { CustomerCharterDetailsDialogModule } from '../../shared/dialogs/customer-charter-details-dialog/customer-charter-details-dialog.module';

@NgModule({
  declarations: [CustomerMyChartersComponent],
  imports: [
    CommonModule,
    CustomerMyChartersRoutingModule,
    MatTabsModule,
    MyChartersCardModule,
    MatButtonModule,
    CustomerCharterDetailsDialogModule,
  ],
})
export class CustomerMyChartersModule {}
